export default __webpack_public_path__ + "static/media/google-play-store.d6b7bc99.svg";